<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi1"><a id="page_vii"></a><em>To my goddaughter Harriet,<br/>who shares my hunger for books and<br/>unlikely adventures</em><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?1ae79a34